$(function(){
	$('.collection-brand-item').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > elemPos - windowHeight + 200){
            $(this).addClass('scrollin');
        }
    });
    
    //パララックス
	$(window).scroll(function() {
		var elem = $('.collection-brand-item');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh + (wh / 6) ){
			  $(this).addClass("scrollin");
			}else{
				$(this).removeClass("scrollin");
			}
		});

	});
});

